module.exports = __webpack_public_path__ + "img/service6.f386645f.png";